import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6ca09acc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "event_body-content" }
const _hoisted_2 = ["href"]
const _hoisted_3 = ["src"]
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "event_body-text" }
const _hoisted_6 = { class: "event-text-wrapper" }
const _hoisted_7 = { class: "event-name" }
const _hoisted_8 = { class: "event_body-countdown" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_event_dates = _resolveComponent("event-dates")!
  const _component_countdown = _resolveComponent("countdown")!
  const _component_swiper_slide = _resolveComponent("swiper-slide")!
  const _component_swiper_container = _resolveComponent("swiper-container")!

  return (_openBlock(), _createBlock(_component_swiper_container, {
    "slides-per-view": 1,
    "space-between": _ctx.spaceBetween,
    loop: true,
    "centered-slides": true,
    pagination: true,
    onProgress: _ctx.onProgress,
    onSlidechange: _ctx.onSlideChange
  }, {
    default: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filterResults(_ctx.data), (e) => {
        return (_openBlock(), _createBlock(_component_swiper_slide, {
          key: `${e.cp_id}`
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", {
              class: _normalizeClass(`event_body${e.version > 0 ? '2' : ''}`)
            }, [
              _createElementVNode("div", _hoisted_1, [
                (e.info_id > 0)
                  ? (_openBlock(), _createElementBlock("a", {
                      key: 0,
                      href: `https://api.heaven-burns-red.wfs.games/web/announcement/${e.info_id}?version=${e.version}&phoneType=4`,
                      target: "_blank",
                      rel: "noopener",
                      class: _normalizeClass(`${`event_info-link alt-size`}`)
                    }, [
                      _createElementVNode("img", {
                        src: `https://assets.hbr.quest/v1/hbr/${e.stl_id}?${_ctx.currentTime}`,
                        alt: "Event",
                        class: "event_image mini"
                      }, null, 8, _hoisted_3)
                    ], 8, _hoisted_2))
                  : (_openBlock(), _createElementBlock("img", {
                      key: 1,
                      src: `https://assets.hbr.quest/v1/hbr/${e.stl_id}?${_ctx.currentTime}`,
                      alt: "Event",
                      class: "event_image mini"
                    }, null, 8, _hoisted_4)),
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("div", _hoisted_7, _toDisplayString(e.name ? e.name : e.category), 1),
                    _createVNode(_component_event_dates, { data: e }, null, 8, ["data"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_8, [
                  _createVNode(_component_countdown, {
                    dates: {
              start: e.in_date,
              end: e.out_date,
            }
                  }, null, 8, ["dates"])
                ])
              ])
            ], 2)
          ]),
          _: 2
        }, 1024))
      }), 128))
    ]),
    _: 1
  }, 8, ["space-between", "onProgress", "onSlidechange"]))
}